<template>
	<svg id="Badge" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
		<g id="Warstwa_2" data-name="Warstwa 2">
			<path
				fill="#2492eb"
				d="M300,33.22V266.78A33.22,33.22,0,0,1,266.78,300H251.89l0,.23h-125c0-.08,0-.15-.07-.23H33.22A33.22,33.22,0,0,1,0,266.78V33.22A33.22,33.22,0,0,1,29.32.23H270.68A33.22,33.22,0,0,1,300,33.22Z"
				transform="translate(0 -0.23)"
			/>
		</g>
		<circle fill="#04e2e5" cx="200.34" cy="245.88" r="17.67" />
		<path
			fill="#04e2e5"
			d="M189.39,283.76a17.71,17.71,0,0,1-11.27,16.47H165.31a17.71,17.71,0,1,1,24.08-16.47Z"
			transform="translate(0 -0.23)"
		/>
		<circle fill="#04e2e5" cx="228.2" cy="206.83" r="17.67" />
		<circle fill="#04e2e5" cx="262.77" cy="233.22" r="17.67" />
		<circle fill="#04e2e5" cx="234.22" cy="271.49" r="17.67" />
		<path fill="#04e2e5" d="M220.09,300.23H190.62a17.71,17.71,0,0,1,29.46,0Z" transform="translate(0 -0.23)" />
		<path
			fill="#04e2e5"
			d="M286.8,293.29a33.08,33.08,0,0,1-20,6.71H251.89a14.7,14.7,0,0,1-.15-2.2,17.71,17.71,0,0,1,35.06-4.51Z"
			transform="translate(0 -0.23)"
		/>
		<path
			fill="#04e2e5"
			d="M300,242.08v24.7a33,33,0,0,1-1.74,10.62A17.71,17.71,0,0,1,296.1,242a17.35,17.35,0,0,1,2.28,0A10.79,10.79,0,0,1,300,242.08Z"
			transform="translate(0 -0.23)"
		/>
		<path
			fill="#04e2e5"
			d="M300,210.73a18,18,0,0,1-8.49,2.08,17.71,17.71,0,1,1-2.43-35.33,19.7,19.7,0,0,1,2.43,0,18.07,18.07,0,0,1,8.49,2.08Z"
			transform="translate(0 -0.23)"
		/>
		<circle fill="#04e2e5" cx="255.98" cy="168.87" r="17.67" />
		<path
			fill="#ff53bf"
			d="M126.85,300H33.22A33.22,33.22,0,0,1,0,266.78V164.47A208.55,208.55,0,0,1,126.85,300Z"
			transform="translate(0 -0.23)"
		/>
		<path
			fill="#ffd401"
			d="M128.93.23A208.35,208.35,0,0,1,0,90V33.22A33.22,33.22,0,0,1,29.32.23Z"
			transform="translate(0 -0.23)"
		/>
		<path
			fill="#ff53bf"
			d="M300,33.22v90.66c-4.26-3.27-8.38-6.69-12.38-10.3h0A208.21,208.21,0,0,1,222.59.23h48.09A33.22,33.22,0,0,1,300,33.22Z"
			transform="translate(0 -0.23)"
		/>
		<path fill="#04e2e5" d="M300,121.15a17.71,17.71,0,1,0,0,20Z" transform="translate(0 -0.23)" />
	</svg>
</template>
